import { connect } from 'react-redux';
import { createToolbarEvent } from '../../../analytics/AnalyticsEvents';
import { sendAnalytics } from '../../../analytics/functions';
import { translate } from '../../../base/i18n/functions';
import { IconCode } from '../../../base/icons/svg';
import AbstractButton from '../../../base/toolbox/components/AbstractButton';
import { toggleNkfLogPanel } from '../../actions';
import { isNkfLogOpen } from '../../functions';
/**
 * Overflow-menu ("詳細な操作") item that shows/hides the NKF-AEC debug LOG panel —
 * moved here from the floating top-left LOG button.
 */
class NkfLogButton extends AbstractButton {
    accessibilityLabel = 'toolbar.accessibilityNkfLog';
    icon = IconCode;
    label = 'toolbar.nkfLog';
    toggledLabel = 'toolbar.nkfLogOff';
    tooltip = 'toolbar.nkfLog';
    /**
     * Toggles the debug LOG panel.
     *
     * @override
     * @protected
     * @returns {void}
     */
    _handleClick() {
        const { _open, dispatch } = this.props;
        sendAnalytics(createToolbarEvent('nkf.log', { enable: !_open }));
        dispatch(toggleNkfLogPanel());
    }
    /**
     * Toggled (ON) when the LOG panel is visible.
     *
     * @override
     * @protected
     * @returns {boolean}
     */
    _isToggled() {
        return this.props._open;
    }
}
/**
 * Maps part of the redux state to the component's props.
 *
 * @param {IReduxState} state - The redux state.
 * @returns {Object}
 */
function mapStateToProps(state) {
    return {
        _open: isNkfLogOpen(state)
    };
}
export default translate(connect(mapStateToProps)(NkfLogButton));
